import { apiRoot } from "services/src/config";

export async function fetchTicketSuggestions({ inputText }) {
  try {
    const response = await apiRoot.post("ai-integration/ticket", { inputText });
    return response.data?.data || response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}